import {registerTemplateGraphNode} from "#template/template-node/register"
import {curveGeometryAttributeSetLike, curveGeometryAttributeSetLikeMarker} from "#template/nodes/geometry-graph/attribute-set/attribute-set-node"
import type {CurveGeometryAttributeSetLikeNode} from "#template/nodes/geometry-graph/attribute-set/attribute-set-node"

import type {TemplateNodeDefinition} from "#template/template-node/types"
import {getTemplateNodeReturns} from "#template/template-node/validation"

import type {MergeOperatorParameters} from "#template/nodes/geometry-graph/attribute-set/merge-operator/geometry-merge-operator-node"
import {
    GeometryMergeOperatorNode,
    mergeOperatorParametersSchema,
} from "#template/nodes/geometry-graph/attribute-set/merge-operator/geometry-merge-operator-node"

export type CurveGeometryMergeOperatorParameters = MergeOperatorParameters<CurveGeometryAttributeSetLikeNode>

const definition: TemplateNodeDefinition<CurveGeometryMergeOperatorParameters> = {
    nodeClass: "CurveGeometryMergeOperator",
    validation: {
        parameters: mergeOperatorParametersSchema(curveGeometryAttributeSetLike),
        returns: getTemplateNodeReturns(),
    },
}

@registerTemplateGraphNode
export class CurveGeometryMergeOperator extends GeometryMergeOperatorNode<1, CurveGeometryAttributeSetLikeNode> implements CurveGeometryAttributeSetLikeNode {
    get [curveGeometryAttributeSetLikeMarker]() {
        return true as const
    }

    public override get definition() {
        return definition
    }
}
